<template>
  <main-layout>

    <!--  左メニュー 開始  -->
    <div slot="left-side">
      <menubar screenIdParam="M-06-06"></menubar>
    </div>

    <el-row slot="header">
      <head-title class="cancel-width">
        <label slot="title">{{$t('title.system.owner.title')}}</label>
        <sp-smart-button @click="backSearchOwner" slot="cancel">{{ $t("button.common.data.cancel") }}</sp-smart-button>
        <narrow-down @click="deviceBatchImport" slot="create">{{$t('button.common.data.capture')}}</narrow-down>
      </head-title>
    </el-row>

    <div slot="body">
      <!-- subtitle -->
      <div class="main-title">
        {{$t('label.system.owner.salesMachine.title')}}
      </div>

      <el-row>
        <el-col class="width-label-div">
          <label >
            {{$t('label.system.owner.salesMachine.ownerExId')}}
          </label>
        </el-col>
        <el-col class="width-label-div">
          <label>{{this.ownerEXId}}</label>
        </el-col>
      </el-row >
      <el-row class="m-top-20px">
        <el-col class="width-label-div">
          <label>
          {{$t('label.system.owner.salesMachine.ownerName')}}
        </label>
        </el-col>
        <el-col class="width-label-div one-line">
          <label>{{this.ownerName}}</label>
        </el-col>
      </el-row>

      <el-row class="m-top-20px">
        <el-col class="width-label-div">
          <label>
            {{$t('label.system.owner.salesMachine.file')}}
          </label>
        </el-col>
        <el-col class="upload-file-div">
          <el-input
            :readonly="true"
            :value="this.fileName"
            placeholder="ファイル"
            class="in-file-url">
          </el-input>
        </el-col>
        <el-col class="width-label-div">
          <sp-smart-button
            @click="uploadfile"
            class="width-146">
            {{$t('label.system.owner.salesMachine.fileUpload')}}
          </sp-smart-button>
          <input
            ref="csvUpload"
            type="file"
            style="display:none"
            accept=".csv,.CSV"
            @change="getCsvfile">
        </el-col>
      </el-row>

      <el-row class="m-top-48px">
        <el-col class="width-label-div">
          <label >
            {{$t('label.system.owner.salesMachine.result')}}
          </label>
        </el-col>
        <el-col class="width-upload-file-textarea">
          <el-input
            :readonly="true"
            id="textarea_result"
            type="textarea">
          </el-input>
        </el-col>
      </el-row>
      <el-dialog-prompt
        :centerDialogVisibleParam.sync="centerDialogVisibleIsShow"
        :msgParam="msgParam">
      </el-dialog-prompt>
    </div>
  </main-layout>
</template>

<script>
import NewDesignLayout from "@/layout/NewDesignLayout";
import SystemManageApi from "@/api/SystemManageApi";
import errorCodeMsg from "@/utils/error-code-msg"
import headTitle from "@/components/common/head/head";
import narrowDown from "@/components/common/generalButton/NarrowDown";
import SpSmartButton from "@/components/common/sp-smart-button";
import elDialogPrompt from "@/components/common/el-dialog-prompt";
import Menubar from "@/components/leftmenu/DashBoard";
import statusErrorCodeMsg from "@/utils/status-error-msg"


export default {
  components:{
    headTitle,
    narrowDown,
    SpSmartButton,
    MainLayout: NewDesignLayout,
    elDialogPrompt,
    Menubar
  },
  data(){
    return{
      msgParam: null,
      centerDialogVisibleIsShow:false,
      query:{
        file:null
      },
      result:{
        successCount:null,
        errorCount:null,
        uploadResult:[{
          lineNo:null,
          message:null
        }]
      },
      resultstr:'',
      fileName:null,
      ownerId:null,
      ownerName:null,
      ownerEXId:null
    }
  },
  methods:{
    //ファイルを取得
    getCsvfile(){
      let csvFile = this.$refs.csvUpload.files[0]
      var csvCheck = /\.(csv|CSV)$/
      if (!csvCheck.test(csvFile.name)) {
        this.query.file = null
        this.msgParam = this.$t('message.common.validation.fileFormat')
        this.centerDialogVisibleIsShow = true
      } else {
        this.query.file = csvFile
        this.fileName = csvFile.name
      }
      const isLt2M = csvFile.size / 1024 / 1024 < 15;
      if (!isLt2M) {
          this.fileName = null;
          this.$messageIotError(this.$t('message.common.error.ERR_FILE_SIZE_OVER_MSG',{size:'15M'}));
          return this.query.file = null
      }
      if (csvFile.size == 0) {
          this.fileName = null;
          this.$messageIotError(this.$t('message.common.error.ERR_FILE_EMPTY_MSG'));
          return this.query.file = null
      }
    },
    //アップロード入力ボックスを開く
    uploadfile() {
      document.getElementById('textarea_result').value = null
      this.query.file = null
      this.fileName = null
      this.$refs.csvUpload.value = null
      this.$refs.csvUpload.click()
    },
    //前のページに戻る
    backSearchOwner () {
      this.$router.back(-1)
    },
    deviceBatchImport(){
      if(this.query.file == null){
        this.msgParam = this.$t('message.common.validation.required', {
        field: this.$t('label.system.owner.salesMachine.file')
        })
        this.centerDialogVisibleIsShow = true
      }else{
        SystemManageApi.salesMachineBatchImport({
          csvFile:this.query.file,
          ownerId:this.ownerId
        })
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({ data }) =>{
           if(!statusErrorCodeMsg(data.statusCode, this)) {
            return this.query.file = null
          }
          if (data.body.failureCount > 0) {
              this.resultstr = this.$t('message.common.csvImport.ERR_FAILURE_MSG');
          } else {
              this.resultstr = this.$t('message.common.csvImport.INFO_SUCCESS_AMOUNT_MSG',{amount:data.body.successCount});
          }
          for (let i = 0; i < data.body.failureDetails.length; i++) {
            let failureDetail = data.body.failureDetails[i]
            this.resultstr = this.resultstr + "\r\n" + this.$t('message.common.csvImport.ERR_' + failureDetail.message + "_MSG",
                            {row:failureDetail.lineNo,
                            column:failureDetail.itemIndex
                            });
          }
          document.getElementById('textarea_result').value = this.resultstr
        })
      }
    }
  },
  created(){
    this.$authCheck("010205")
    this.ownerId = this.$route.params.ownerId
    this.ownerEXId = this.$route.params.ownerExId
    this.ownerName = this.$route.params.ownerName

    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "/system/owners/search",
        title: "label.router.owner",
      },
      {
        path: "",
        title: "label.router.marcheSettingDataFileImport",
      }
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);
  }
}
</script>

<style lang="scss" scoped>
::v-deep .cancel-width{
  .my-button{
    width: 152px;
    height: 32px;
  }
}
.width-label-div{
  width: 204px;
  height: 40px;
  float: left;
  line-height: 40px;
}
.width-div-input{
  width: 200px;
  height: 30px;
  float: left;
}
.upload-file-div{
  float: left;
  width: 340px;
  height: 40px;
  line-height: 40px;
}
.width-upload-file-textarea{
  width: 700px;
}
::v-deep.upload-file-div{
  .el-input__inner{
  width: 324px;
  height: 44px !important;
  border-radius: 8px !important;
  background: #F2F2ED;
  border: none;
  padding:0px 0px 0px 16px;
  box-shadow: -2px -2px 5px #ffffff inset, -2px -2px 5px #ffffff inset,
    4px 5px 5px #E6E6E1 inset, 4px 5px 5px #E6E6E1 inset;
  }
}
.width-146{
  width: 146px;
}

.width-upload-file-textarea::v-deep {
  .el-textarea__inner{
    border-radius: 6px !important;
    background: #DEDED9 !important;
    width: 596px !important;
    height: 237px !important;
    box-shadow: none !important;
  }
}

.m-top-20px {
  margin-top: 20px;
}

.m-top-48px {
  margin-top: 48px;
}
.one-line{
  white-space: nowrap;
}
</style>
